<template>
  <div
    :id="id"
    class="modal fade"
    data-backdrop="static"
    tabindex="-1">
    <div class="bottom modal-dialog modal-bottom white b-r">
      <div class="row-col">
        <a
          class="pull-right text-muted text-lg p-a-sm m-r-sm"
          @click="closeModal">×</a>
        <div class="p-a b-b">
          <span class="h5">
            <slot name="header-text"/>
          </span>
        </div>
        <div class="row-row">
          <div class="row-body">
            <div class="row-inner">
              <slot name="body"/>
            </div>
          </div>
        </div>
        <div class="row b-t">
          <div class="col-md-6">
            <div class="p-a text-left">
              <slot name="popup"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-a text-right">
              <button
                :disabled="loading"
                class="btn btn-fw white"
                @click="closeModal">{{ cancelText }}
              </button>
              <slot name="footer"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },

        cancelText: {
            type: String,
            default: 'Close',
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.registerEvent();

        $(this.$el).on('show.bs.modal', e => {
            $(document.body).addClass('modal-bottom');
        });

        $(this.$el).on('hidden.bs.modal', e => {
            $(document.body).removeClass('modal-bottom');
            this.$emit('modal-hidden');
        });
    },

    methods: {
        registerEvent() {
            this.$on('show', () => this.showModal());
            this.$on('hide', () => this.hideModal());
        },

        showModal() {
            $(`#${this.id}`).modal('show');
        },

        hideModal() {
            $(`#${this.id}`).modal('hide');
        },

        closeModal() {
            this.hideModal();
        },
    },
};
</script>
